import { configureStore } from '@reduxjs/toolkit';
import * as Core from './store/core';
import * as Catalogue from './store/catalogue';
import * as FurnitureList from './store/furnitureList';
import * as ProductData from './store/productData';
import * as Loading from './store/loading';
import * as ModaSofaTemplates from './store/modaSofaTemplates';
import * as ConversionId from './store/conversionId';
import * as Log from './store/middleware/log';
import * as Track from './store/middleware/track';
import * as ConfigurableProperties from './store/configurableProperties';
import * as InitialConfiguration from './store/initialConfiguration';
import * as VariantData from './store/variantData';

export const store = configureStore({
    reducer: {
        core: Core.reducer,
        productData: ProductData.reducer,
        catalogue: Catalogue.reducer,
        furnitureList: FurnitureList.reducer,
        loading: Loading.reducer,
        modaSofaTemplates: ModaSofaTemplates.reducer,
        conversionId: ConversionId.reducer,
        configurableProperties: ConfigurableProperties.reducer,
        configuration: InitialConfiguration.reducer,
        variantData: VariantData.reducer,
    },
    middleware: [Log.middleware, Track.middleware],
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
